<div class="horizontal-bar-dots-chart alternating-values">
  <div class="chart-title" *ngIf="title">{{ title }}</div>

  <div class="title-divider"></div>

  <div class="bars-container">
    <div class="bar-item"
         *ngFor="let item of data; let i = index"
         (mouseenter)="showTooltip(i, $event)"
         (mouseleave)="hideTooltip()">
      <div class="bar-label">{{ item.name }}</div>

      <div class="bar-container">
        <div class="main-bar">
          <!-- Primeiro ponto - Concessionária -->
          <div class="dot dot-1"
               [style.left]="getPosition(item.values[0])"
               [style.background-color]="dotColors[0]"
               [class.value-top]="item.valuePositions && item.valuePositions[0] === 'top'"
               [class.value-bottom]="item.valuePositions && item.valuePositions[0] === 'bottom'">
            <span class="dot-value">{{ item.values[0] }}%</span>
          </div>

          <!-- Segundo ponto - Referência Regional -->
          <div class="dot dot-2"
               [style.left]="getPosition(item.values[1])"
               [style.background-color]="dotColors[1]"
               [class.value-top]="item.valuePositions && item.valuePositions[1] === 'top'"
               [class.value-bottom]="item.valuePositions && item.valuePositions[1] === 'bottom'">
            <span class="dot-value">{{ item.values[1] }}%</span>
          </div>

          <!-- Terceiro ponto - Referência Nacional -->
          <div class="dot dot-3"
               [style.left]="getPosition(item.values[2])"
               [style.background-color]="dotColors[2]"
               [class.value-top]="item.valuePositions && item.valuePositions[2] === 'top'"
               [class.value-bottom]="item.valuePositions && item.valuePositions[2] === 'bottom'">
            <span class="dot-value">{{ item.values[2] }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- TOOLTIP ÚNICO FORA DO LOOP -->
  <div class="bar-tooltip"
       *ngIf="activeTooltipIndex !== null"
       [ngStyle]="tooltipStyle"
       (mouseenter)="cancelHideTooltip()"
       (mouseleave)="hideTooltipImmediately()">
    <div class="tooltip-content">
      <div class="tooltip-title">{{ data[activeTooltipIndex!].name }}</div>
      <div class="tooltip-items">
        <div class="tooltip-item" *ngFor="let legend of legendItems; let j = index">
          <div class="tooltip-color" [style.background-color]="legend.color"></div>
          <span class="tooltip-label">{{ legend.label }}:</span>
          <span class="tooltip-value">{{ data[activeTooltipIndex!].values[j] }}%</span>
        </div>
        <div class="tooltip-divider"></div>
      </div>
    </div>
    <div class="tooltip-arrow"></div>
  </div>

  <!-- LEGENDA -->
  <div class="chart-legend">
    <div class="legend-item" *ngFor="let legend of legendItems">
      <div class="legend-color" [style.background-color]="legend.color"></div>
      <span class="legend-label">{{ legend.label }}</span>
    </div>
  </div>
</div>
